import React from 'react';
import { Icon } from './Icon.jsx';

export function IconButton({
  icon,
  label,
  variant = 'ghost',
  size = 'md',
  active = false,
  fill = false,
  className = '',
  ...rest
}) {
  return (
    <button
      className={`bjl-iconbtn bjl-iconbtn--${size} ${variant !== 'ghost' ? `bjl-iconbtn--${variant}` : ''} ${active ? 'is-active' : ''} ${className}`}
      aria-label={label}
      title={label}
      {...rest}
    >
      <Icon name={icon} fill={fill || active} size="1em" style={{ verticalAlign: 0 }} />
    </button>
  );
}
